<template>
  <div class="aplication">
    <div class="wrapper">
      <Tarja></Tarja>
      <Banner></Banner>
      <div class="container conteudo">
        <template>
          <router-view />
        </template>
      </div>
      <Footer></Footer>     
    </div>

    <el-dialog
      class="ss-loading"
      top="0"
      width="200px"
      :visible.sync="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
    >
      <div style="text-align: center">
        <img src="/public/img/loading.gif" />
      </div>
    </el-dialog>
    <div v-if="getAmbiente() == 'homologacao'" class="tarja-ambiente-beta">
      Atenção! Este é um ambiente de teste - as matrículas realizadas aqui não possuem validade.
    </div>
  </div>
</template>
<script>
import Banner from '../components/Banner.vue';
import Footer from '../components/Footer.vue';
import Tarja from '../components/Tarja.vue';

export default {  
  name: "index",  
  data: () => ({
    loading: null,
  }),
  async mounted() {
    this.carregarMenus();
  },
  methods: {
    carregarMenus() {
      // Busca os cards visíveis da home (endpoint público, sem auth). Em caso de erro,
      // libera todos os cards (fail-open) para não bloquear o portal público.
      const padrao = { lista_espera: true, inscricao: true, cancelar: true, consultar: true, calendario: true, contato: true, faq: true };
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/parametro-sistema-public/pre-matricula-menus`)
        .then(r => { this.$store.commit('setMenus', (r.data && typeof r.data === 'object') ? r.data : padrao); })
        .catch(() => { this.$store.commit('setMenus', padrao); });
    },
    getAmbiente() {

      return 'producao';

      if((window.location.href).includes("https://escolar.pmvc.ba.gov.br")) {
        return 'producao';
      }else if((window.location.href).includes("localhost")) {
        return 'local';
      }
      return 'homologacao';
    },
  },
  created: function () {
    window.eventBus.$on("alert", (data) => {
      let time = 3000;
      if (data.type == "error" || data.type == "warning") {
        time = 6000;
      }
      this.$message({
        message: data.msg,
        type: data.type,
        duration: time,
      });
    });

    window.eventBus.$on("loading", (data) => {
      this.loading = data;
    });
  },
  components: { Banner, Tarja, Footer },
};
</script>
<style>
  .tarja-ambiente-beta {
    background-color: #ff0000;
    color: #fff;
    text-align: center;
    font-weight: bold;
    padding: 5px;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
</style>